import Typography from "@material-ui/core/Typography";
import { some, SUCCESS_CODE } from "constants/constants";
import Footer from "layout/Footer";
import MainHeader from "layout/MainHeader";
import { snackbarSetting } from "modules/common/Elements";
import { useSnackbar } from "notistack";
import React from "react";
import { useLocation } from "react-router-dom";
import { checkDeviceType } from "utils/helpers/helpers";
import { ReactComponent as IcDiamond } from "../../../../assets/icons/ic_diamond.svg";
import { ReactComponent as IcGold } from "../../../../assets/icons/ic_gold.svg";
import { ReactComponent as IcMember } from "../../../../assets/icons/ic_member.svg";
import { ReactComponent as IcNotFound } from "../../../../assets/icons/ic_nosearchresult.svg";
import { ReactComponent as IcSilver } from "../../../../assets/icons/ic_silver.svg";
import { ReactComponent as IcWhiteGold } from "../../../../assets/icons/ic_whitegold.svg";
import { actionGetBookerInfo, actionPackagesOfUsers } from "../bookerAction";
import BookerInfoBoxDesktop from "./BookerInfoBoxDesktop";
import BookerInfoBoxMobile from "./BookerInfoBoxMobile";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

interface Props {
  location: some;
}
const BookerInfoBox: React.FC<Props> = (props) => {
  const { location } = props;
  let query = useQuery();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const phone = query.get("phone");

  let info = location?.state;

  const [results, setResults] = React.useState<some>(info);
  const [vipInfo, setVipInfo] = React.useState<some>();

  const getPackagesOfUsers = React.useCallback(
    async (dataPost: any) => {
      try {
        const res: some = await actionPackagesOfUsers(dataPost);
        if (res?.code === SUCCESS_CODE) {
          setVipInfo(res?.data);
        } else {
          enqueueSnackbar(
            res?.message,
            snackbarSetting((key) => closeSnackbar(key), { color: "error" })
          );
        }
      } catch (error) {}
    },
    [closeSnackbar, enqueueSnackbar]
  );

  const getBookerInfo = React.useCallback(async () => {
    try {
      const res: some = await actionGetBookerInfo(phone as string);
      if (res?.code === SUCCESS_CODE) {
        setResults(res?.data);
        console.log("res?.data?.userId", res?.data?.userId);
        const dataPost = { userIds: [res?.data?.userId] };
        getPackagesOfUsers(dataPost);
      } else {
        enqueueSnackbar(
          res?.message,
          snackbarSetting((key) => closeSnackbar(key), { color: "error" })
        );
      }
    } catch (error) {}
  }, [closeSnackbar, enqueueSnackbar, getPackagesOfUsers, phone]);

  React.useEffect(() => {
    if (!info && phone) {
      getBookerInfo();
    } else {
      const dataPost = { userIds: [info?.userId] };
      getPackagesOfUsers(dataPost);
      setResults(info);
    }
  }, [getBookerInfo, getPackagesOfUsers, info, phone]);

  let sumBookings: number =
    results?.bookingInfo?.tourBookingNum +
    results?.bookingInfo?.hotelBookingNum +
    results?.bookingInfo?.flightBookingNum +
    results?.bookingInfo?.trainBookingNum +
    results?.bookingInfo?.transportationBookingNum;

  const getRankingIcon = () => {
    if (results?.rank === "Thành viên mới") return <IcMember />;
    if (results?.rank === "Vàng") return <IcGold />;
    if (results?.rank === "Bạc") return <IcSilver />;
    if (results?.rank === "Kim Cương") return <IcDiamond />;
    else return <IcWhiteGold />;
  };

  return (
    <>
      <MainHeader />
      {!results ? (
        <div style={{ margin: "0 auto" }}>
          <IcNotFound style={{ margin: "10 auto" }} />
          <Typography variant="caption">
            Không tìm thấy Booker tương ứng với mã mà Quý khách đã nhập. Vui
            lòng kiểm tra lại mã của Booker
          </Typography>
        </div>
      ) : checkDeviceType()?.device?.type === "mobile" ? (
        <BookerInfoBoxMobile
          sumBookings={sumBookings}
          getRankingIcon={getRankingIcon}
          info={results}
          vipInfo={vipInfo}
        />
      ) : (
        <BookerInfoBoxDesktop
          sumBookings={sumBookings}
          getRankingIcon={getRankingIcon}
          info={results}
          vipInfo={vipInfo}
        />
      )}

      <Footer />
    </>
  );
};

export default BookerInfoBox;
